













import { defineComponent, ref, computed, PropType, watch, toRefs } from '@vue/composition-api';
import { KeyType, KeyInfo, ResizeStrategy, CarouselImageSettingInfo } from '@tt4b/ttam-enums';
import { MessageBox } from 'byted-vui';
import { i18n } from './../../../i18n';
import { useImageSettingStore } from './hooks';
import Fields from './fields.vue';
import EditModal from './edit-modal.vue';

const name = 'ttam-image-settings-enhancements-compose';
export default defineComponent({
  name,
  components: {
    Fields,
    EditModal,
  },
  props: {
    creativeUuid: {
      type: String,
      required: true,
    },
    carouselImageInfo: {
      type: Object as PropType<CarouselImageSettingInfo>,
      default: () => ({
        keyType: KeyType.Disabled,
        keyInfo: KeyInfo.WithoutKeyInfo,
        resizeStrategy: ResizeStrategy.Original,
      }),
    },
  },
  setup(props) {
    const { creativeUuid } = toRefs(props);
    const { getImproveTaskStatus } = useImageSettingStore();
    const isRunning = computed(() => {
      const { loading } = getImproveTaskStatus(creativeUuid.value);
      return loading;
    });

    const isEdit = ref(false);

    const handleEdit = async () => {
      try {
        if (isRunning.value) {
          await MessageBox.confirm(
            i18n.t('module_image_settings_hint') as string,
            i18n.t('module_image_settings_header') as string,
            {
              confirmButtonText: i18n.t('module_image_settings_submit') as string,
              cancelButtonText: i18n.t('common_cancel') as string,
            },
          );
        }

        isEdit.value = true;
      } catch {}
    };

    return {
      name,
      isEdit,
      handleEdit,
    };
  },
});
